<!--
* 组件名 : 话在肉身显现
* 开发者 : JY
*
* 参数:
*   pageDataItem  { Object } -  书籍数据
*
* 事件: null
*   
-->

<template>
  <section class="the-word-appears-in-the-flesh-wrap" v-parallax>
    <v-page
      :background="[
        'images/the-word-appears-in-the-flesh/bg.jpg',
        'images/the-word-appears-in-the-flesh/bg-front.png',
      ]"
      v-slide-up-in
      :slide-up-in="true"
      v-parallax-background
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        v-slide-up-in-stage="1"
      />
      <v-btn class="down-arrow"><v-icon>expand_more</v-icon></v-btn>
    </v-page>
    <v-page :background="theme.colors.cyan">
      <book-wrap-content
        :pageDataItem="pageDataItem"
        :bookInfo="theWordAppearsInTheFlesh"
      />
    </v-page>
    <v-page :background="theme.colors.cyan">
      <v-chatper-entry class="margin0" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";
import bookWrapContent from "./components/book-contents/index.vue";

export default {
  components: {
    bookWrapContent,
  },
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      firstPageData: {},
    };
  },

  created() {
    this.pageDataItem = this.schema["the-word-appears-in-the-flesh"].item[
      "the-word-appears-in-the-flesh"
    ].data;

    this.theWordAppearsInTheFlesh = this.schema.global.item[
      "the-word-appears-in-the-flesh"
    ].data;

    this.chapterTitle = this.schema["the-word-appears-in-the-flesh"].item[
      "the-word-appears-in-the-flesh"
    ].title;

    this.firstPageData = this.schema.global.item.aside.data[7];
  },
};
</script>
<style lang="scss">
.the-word-appears-in-the-flesh-wrap {
  .chapter-title-wrapper {
    padding-top: 10%;
  }

  @media (max-width: $lx-min - 1px) {
    .chapter-title-wrapper {
      padding-top: 9%;
    }
  }
}
</style>
